import React from "react";
import { Box } from "@mui/material";
import CustomAppBar from "../components/appbar";
import BidDetailsPage from "../components/bidDetailsPage";
import { useLocation } from "react-router-dom";


const BidView = () => {
    const location = useLocation();
    const from = location.state?.from;
    return (
        <Box>
            <CustomAppBar active={from} />
            <BidDetailsPage />
        </Box>
    );
}

export default BidView;